import { useState, ReactElement, ChangeEvent } from 'react';
import {
  Container, Row, Col, Form, Tabs, Tab, Button,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { Scroll } from '../../components';
import { StateRedux } from '../../store/type-redux';
import pp from './utils/pp.js';
import tdu from './utils/tdu.js';
import { api } from '../../utils';

const templatePp = { __html: pp };
const templateTdu = { __html: tdu };
const TermsAndPolicy = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { access } = useSelector((state: StateRedux) => state);
  const [termos, settermos] = useState('');

  const handleConcluir = async () => {
    if (!termos) {
      toast.warn('Por favor aceite os termos para prosseguir');
      return;
    }

    if (Number(termos) === 0) {
      toast.warn('É necessário aceitar os termos para prosseguir');
      // limpa token salvo no local storage
      localStorage.setItem('token', '');
      navigate('/login');
      return;
    }

    // Aceita termos para usuário pela procedure SQL
    await api.setTermos();

    dispatch({
      type: 'ACCESS',
      access: {
        ...access,
        termos: true,
        resetPassword: true,
      },
    });

    navigate('/home');
  };

  return (
    <Container>
      <Row>
        <Col
          xl={12}
          style={{
            marginTop: 20,
          }}
        >
          <>
            <h3 className="text-center">
              <small className="text-muted">
                Bem-vindo(a) ao termos de uso e politica de privacidade.
              </small>
            </h3>
            <h4 className="text-center">
              <small className="text-muted">
                Revise os termos de uso e marque a opção de sua preferencia ao final desta pagina
              </small>
            </h4>
          </>
          <Tabs defaultActiveKey="termos" className="mb-3">
            <Tab eventKey="termos" title="Termos de uso">
              <Scroll height={700}>
                <div dangerouslySetInnerHTML={templateTdu} />
              </Scroll>
            </Tab>
            <Tab eventKey="politica" title="Politica de privacidade">
              <Scroll height={700}>
                <div dangerouslySetInnerHTML={templatePp} />
              </Scroll>
            </Tab>
          </Tabs>
          <br />
          <>
            <Form.Check
              type="radio"
              label="Não aceito"
              name="termos"
              id="inline-radio-1"
              value={0}
              inline
              onChange={(e: ChangeEvent<HTMLInputElement>) => settermos(e.target.value)}
            />
            <Form.Check
              type="radio"
              label="Aceito"
              name="termos"
              id="inline-radio-2"
              value={1}
              inline
              onChange={(e: ChangeEvent<HTMLInputElement>) => (
                settermos(e.target.value)
              )}
            />
          </>
          <Button
            variant="primary"
            type="submit"
            onClick={handleConcluir}
          >
            Concluir
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsAndPolicy;
